export default __webpack_public_path__ + "static/media/ottweiler_dark.4d09fe8b.png";